// Event details for 33 RPM — Fine Dining in Rotation
export const EVENT = {
  brand: "33 RPM",
  tagline: "Fine Dining in Rotation",
  city: "Downtown Chicago",
  address: "235 West Van Buren Street",
  dateLong: "Saturday, June 27, 2026",
  time: "6:00 PM — 10:00 PM",
  dateShort: "27 . 06 . 2026",
};

// The invited guest list — guests find their name to RSVP
export const GUEST_LIST = [
  "Valerie M.",
  "Marcy L.",
  "Preston L.",
  "Nickle B.",
  "Venus W.",
  "Patricia S.",
  "Arielle P.",
];

export const MENU_COURSES = [
  {
    label: "To Begin",
    title: "Smoky Garlic House Bread",
    desc: "Warm, blistered house bread brushed with smoky garlic — the table's opening note.",
  },
  {
    label: "Mezze",
    title: "Crispy Short Rib Hummus",
    desc: "Slow-braised short rib, silky hummus, herb oil — served with fresh house bread.",
  },
  {
    label: "Greens",
    title: "Aba Chopped Salad",
    desc: "Crisp greens, fresh herbs, vegetables, and feta tossed in a bright house dressing — the table's clean, green pause.",
  },
  {
    label: "From the Hearth",
    title: "Crispy Potatoes",
    desc: "Golden, hand-cut crispy potatoes with mizithra (cheese) on the side.",
  },
  {
    label: "Main",
    title: "Grilled Chicken Kebab",
    desc: "Charcoal-grilled marinated chicken kebab, char-kissed and tender.",
  },
  {
    label: "Main",
    title: "Grilled Salmon Kebab",
    desc: "Flame-grilled salmon kebab, bright, smoky, and beautifully rendered.",
  },
  {
    label: "Accompaniment",
    title: "Extra Lemon Dill Basmati Rice",
    desc: "Fragrant basmati lifted with fresh lemon and dill — a generous side for the table.",
  },
  {
    label: "Accompaniment",
    title: "House Bread",
    desc: "An additional round of the warm house bread — because everyone always wants more.",
  },
  {
    label: "For the Table",
    title: "Gluten-Free Crackers",
    desc: "Crisp gluten-free crackers, set out for those who prefer them.",
  },
];

export const SIGNATURE_COCKTAILS = [
  {
    label: "The B-Side",
    title: "The B-Side",
    desc: "SirDavis American Whisky, honey, lemon, aromatic bitters, orange peel.",
  },
  {
    label: "Track One",
    title: "Track One",
    desc: "Don Julio Blanco, fresh lime, agave nectar, orange liqueur.",
  },
];

export const BAR_PROGRAM = [
  {
    heading: "Wine",
    groups: [
      { sub: "White", items: ["Sauvignon Blanc", "Chardonnay"] },
      { sub: "Red", items: ["Pinot Noir", "Cabernet Sauvignon"] },
    ],
  },
  {
    heading: "Beer",
    groups: [{ sub: "", items: ["Modelo Especial", "Stella Artois"] }],
  },
  {
    heading: "Spirits",
    groups: [
      {
        sub: "",
        items: [
          "SirDavis American Whisky",
          "Don Julio Blanco",
          "Tito's Handmade Vodka",
          "Hendrick's Gin",
        ],
      },
    ],
  },
  {
    heading: "Non-Alcoholic",
    groups: [
      { sub: "", items: ["Sparkling Water", "Still Water", "Soft Drinks"] },
    ],
  },
];

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_vinyl-supper-club/artifacts/9qlchhwq_5DBCB735-D27A-4D62-AECC-B8E4BA32F271.png";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vinyl-supper-club/artifacts/o363kz1j_6BE19659-4C7A-4EC5-B435-A45D66431146.png";

export const IMAGES = {
  vinyl:
    "https://customer-assets.emergentagent.com/job_vinyl-supper-club/artifacts/0flbjfm6_IMG_5345.jpeg",
  dining:
    "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  cocktail:
    "https://images.unsplash.com/photo-1778104959469-0861d423de46?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  attire:
    "https://customer-assets.emergentagent.com/job_vinyl-supper-club/artifacts/v811oizg_E7CC8FE4-E77B-4EC8-BDA4-52E424FA6529.png",
};
